<template>
    <div class="login-page">
        <div class="login-page__bg"></div>
        <div class="login-box">
            <div class="card card-outline card-primary">
                <div class="card-header text-center">
                    <a href="javascript:void(0)" class="h3">DBHUB Viewer for Kintone</a>
                </div>
                <div class="text-center mt-2">
                    <img class="logo-login" src="../../assets/img/consulting.svg" alt="" />
                </div>
                <div class="card-body">
                    <form>
                        <h6 class="text-center">{{ $t('pageLogin.loginDescription') }}</h6>
                        <div class="mb-3">
                            <label for="email" class="mb-0"
                                >{{ $t('pageLogin.email') }}
                                <span class="text-danger"> *</span>
                            </label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    id="email"
                                    v-model="email"
                                    @keydown="validate('email')"
                                    @keyup="validate('email')"
                                    class="form-control"
                                    :class="{ 'input-valid': errorInfo.email }"
                                    :placeholder="$t('pageLogin.email')"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-envelope"></span>
                                    </div>
                                </div>
                            </div>
                            <error-message-auth :error="errorInfo.email"></error-message-auth>
                        </div>
                        <div class="mb-3">
                            <label for="password" class="mb-0"
                                >{{ $t('pageLogin.password') }}
                                <span class="text-danger"> *</span>
                            </label>
                            <div class="input-group input-group__password">
                                <input
                                    :type="isShowPassword ? 'text' : 'password'"
                                    id="password"
                                    v-model="password"
                                    @keydown="validate('password')"
                                    @keyup="validate('password')"
                                    @keyup.enter="handleLogin"
                                    class="form-control"
                                    :class="{ 'input-valid': errorInfo.password }"
                                    :placeholder="$t('pageLogin.password')"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-lock"></span>
                                    </div>
                                </div>
                                <span class="password-icon">
                                    <i @click="isShowPassword = !isShowPassword" class="fas" :class="{ 'fa-eye': isShowPassword, 'fa-eye-slash': !isShowPassword }"></i>
                                </span>
                            </div>
                            <error-message-auth :error="errorInfo.password"></error-message-auth>
                        </div>
                    </form>

                    <div class="social-auth-links text-center mt-4 mb-3">
                        <button v-loading="isLoading" :disabled="isLoading" class="btn btn-block btn-primary" @click="handleLogin">
                            {{ $t('button.login') }}
                        </button>
                    </div>
                    <p class="mb-1 text-back text-right">
                        <a href="javascript:void(0)" @click="goPath('/forgot-password')">{{ $t('pageLogin.forgot') }}</a>
                    </p>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-custom dialog-custom-small" :visible.sync="selecTypeUser">
            <template slot="title">
                <h5 class="modal-title">{{ $t('titleConfirm') }}</h5>
            </template>
            <div class="mb-3 text-bold">
                {{ $t('pageLogin.confirmSelectTypeEmail') }}
            </div>
            <div class="mb-3">
                <div class="form-group d-flex">
                    <label class="d-flex align-items-center mr-4 cursor-pointer" v-for="(item, index) in TYPE_USER_LOGIN" :key="index" :for="'type' + index">
                        <input class="radio_animated mr-1 cursor-pointer" :id="'type' + index" v-model="type" :value="item.value" type="radio" />
                        {{ item.label }}
                    </label>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <div class="text-right py-2">
                    <Button type="warning" @click="selecTypeUser = false" classes="mr-2 btn-sm">
                        {{ $t('button.cancel') }}
                    </Button>
                    <Button type="primary" :disabled="isLoading" v-loading="isLoading" @click="handleLogin" classes="btn-sm">
                        {{ $t('button.login') }}
                    </Button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { APP_TOKEN_NAME, TYPE_USER_LOGIN } from '@/config/constants';
import { validEmail, validRequired, validDuplicator, validPassword, generateStorageKey } from '@/utils';
import ErrorMessageAuth from '@/views/auth/errorMessageAuth';
import Button from '@/components/partials/Button.vue';

export default {
    name: 'login',
    components: { Button, ErrorMessageAuth },
    data() {
        return {
            selecTypeUser: false,
            TYPE_USER_LOGIN,
            type: TYPE_USER_LOGIN[1].value,
            email: '',
            password: '',
            isShowPassword: false,
            isLoading: false,
            errorInfo: {
                email: '',
                password: ''
            }
        };
    },
    mounted() {
        let token = this.$cookies.get(generateStorageKey(APP_TOKEN_NAME));
        if (token) {
            this.$router.push({ path: '/' });
        } else {
            localStorage.setItem(APP_TOKEN_NAME, '');
            this.$cookies.set(generateStorageKey(APP_TOKEN_NAME), '');
        }
    },
    methods: {
        goPath(path) {
            if (path) {
                this.$router.push(path);
            }
        },
        handleLogin: async function () {
            let check = this.validate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                if (!this.selecTypeUser) {
                    let checkEmail = await this.verifyEmailLogin();
                    if (!checkEmail) {
                        this.isLoading = false;
                        return;
                    }
                }
                let successCallback = (response) => {
                    let { data } = response.data;
                    this.selecTypeUser = false;
                    this.$store.commit('auth/auth_success', { userInfo: data.user });
                    localStorage.setItem('KB_DEV_CUSTOMER', JSON.stringify(data.user));
                    localStorage.setItem(APP_TOKEN_NAME, data.token);
                    let d = new Date();
                    d.setTime(d.getTime() + 24 * 60 * 60 * 60 * 1000);
                    this.$cookies.set(generateStorageKey(APP_TOKEN_NAME), data.token, d.toUTCString());
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('pageLogin.loginSuccess')
                    });
                    if (data.user.type === 1) {
                        this.$router.push({ path: '/share-user-children' });
                    }
                    if (data.user.type === 2) {
                        this.$router.push({ path: '/data-link-multi' });
                    }
                    if (data.user && data.user.type === 2) {
                        if (!data.user.has_setting) {
                            this.$store.commit('noticeSystem/SET_CONFIRM', {
                                type: `warning`,
                                isShowConfirm: true,
                                message: this.$t('msg.hasNotSettingAccountKintone'),
                                callback: () => {
                                    this.$router.push({ name: 'settingKintone' });
                                }
                            });
                        }
                    }
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.selecTypeUser = false;
                    this.isLoading = false;
                };
                let payload = {
                    data: {
                        email: this.email,
                        password: this.password,
                        ...(this.selecTypeUser && { type: this.type })
                    },
                    successCallback,
                    errorCallback
                };

                this.$store.dispatch('auth/login', payload);
            }
        },
        verifyEmailLogin() {
            let successCallback = (response) => {
                let data = response.data.data;
                if (data?.check) return true;
                if (!data?.check) {
                    this.selecTypeUser = true;
                    return false;
                }
            };
            let errorCallback = () => {
                return false;
            };
            let payload = {
                email: this.email,
                successCallback,
                errorCallback
            };
            return this.$store.dispatch('auth/verifyEmailLogin', payload);
        },
        validate(field) {
            let check = true;
            if (field === 'email' || !field) {
                if (!validRequired(this.email)) {
                    this.errorInfo.email = this.$t('pageLogin.errorMail');
                    check = false;
                } else if (!validEmail(this.email.trim())) {
                    this.errorInfo.email = this.$t('pageLogin.errorMailFormat');
                    check = false;
                } else {
                    this.errorInfo.email = '';
                }
            }
            if (field === 'password' || !field) {
                if (!validRequired(this.password)) {
                    this.errorInfo.password = this.$t('pageLogin.errorPass');
                    check = false;
                } else if (this.password && !validDuplicator(this.password)) {
                    this.errorInfo.password = this.$t('pageLogin.passSame');
                    check = false;
                } else if (this.password && (!validPassword(this.password) || this.password.length < 8 || this.password.length > 32)) {
                    this.errorInfo.password = this.$t('pageLogin.passFormat');
                    check = false;
                } else {
                    this.errorInfo.password = '';
                }
            }
            return check;
        }
    }
};
</script>

<style lang="scss" scoped>
.login-page {
    &__bg {
        background-image: url('../../assets/images/12-8.jpg');
    }
}
</style>
